<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" max-width="300" max-height="400">
        <template v-slot:activator="{props}">
            <v-text-field
                :model-value="nightsLabel"
                bg-color="white"
                variant="outlined"
                single-line
                hide-details
                readonly
                :class="{caption: $breakpoint.smAndDown}"
                v-bind="props"
            />
        </template>
        <v-card>
            <v-list density="compact">
                <v-list-item>
                    <v-row dense>
                        <v-col cols="6" class="text-center">
                            <label>{{ $t('from') }}</label>
                            <v-text-field
                                :key="keyNightsFrom"
                                :model-value="nightsFrom"
                                append-icon="mdi-plus"
                                prepend-icon="mdi-minus"
                                type="number"
                                class="pa-0 ma-0 input--no-arrows"
                                @click:append="increment('nightsFrom')"
                                @click:prepend="decrement('nightsFrom')"
                                @update:model-value="inputNightsFrom"
                            />
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <label>{{ $t('tours.to') }}</label>
                            <v-text-field
                                :key="keyNightsTo"
                                :model-value="nightsTo"
                                append-icon="mdi-plus"
                                prepend-icon="mdi-minus"
                                type="number"
                                class="pa-0 ma-0 input--no-arrows"
                                @click:append="increment('nightsTo')"
                                @click:prepend="decrement('nightsTo')"
                                @update:model-value="inputNightsTo"
                            />
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class NightsSelectMenu extends Vue {
        @Prop({default: 2}) _nightsFrom
        @Prop({default: 5}) _nightsTo

        menu = false
        keyNightsFrom = 0
        keyNightsTo = 0

        @Emit()
        changeNightsFrom(val) {
            if (val > this.nightsTo) this.nightsTo = val

            return val
        }
        @Emit()
        changeNightsTo(val) {
            if (this.nightsFrom > val) this.nightsFrom = val

            return val
        }

        beforeUnmount() {
            this.$refs.menu.activatorNode = null
        }

        increment(type) {
            if (type === 'nightsFrom') {
                if (this.nightsFrom === 30) {
                    this.nightsTo = this.nightsFrom
                    return
                }
                this.nightsFrom++
            }
            if (type === 'nightsTo') {
                if (this.nightsTo === 30) return
                else this.nightsTo++
            }
        }

        async decrement(type) {
            if (type === 'nightsFrom') {
                if (this.nightsFrom === 1) return
                this.nightsFrom--
            }
            if (type === 'nightsTo') {
                if (this.nightsTo === 1) {
                    this.nightsFrom = this.nightsTo
                    return
                }
                this.nightsTo--
            }
        }

        inputNightsFrom(v) {
            let value = !v ? 0 : parseInt(v.length > 2 ? v.slice(-1) : v, 10)
            if (value < 1 && String(value).length > 1) value = 1
            else if (value === 0 && String(value).length <= 1) value = 1
            else if (value > 30) value = 30
            if (this.nightsFrom === value) this.keyNightsFrom++
            this.nightsFrom = value
        }

        inputNightsTo(v) {
            let value = !v ? 0 : parseInt(v.length > 2 ? v.slice(-1) : v, 10)
            if (value < 1 && String(value).length > 1) value = 1
            else if (value === 0 && String(value).length <= 1) value = 1
            else if (value > 30) value = 30
            if (this.nightsTo === value) this.keyNightsTo++
            this.nightsTo = value
        }

        get nightsLabel() {
            return `${this.nightsFrom} - ${this.nightsTo}  ${this.$t('night', this.nightsTo)}`
        }

        get nightsFrom() {
            return this._nightsFrom
        }

        set nightsFrom(val) {
            this.changeNightsFrom(val)
        }

        get nightsTo() {
            return this._nightsTo
        }

        set nightsTo(val) {
            this.changeNightsTo(val)
        }
    }

    export default NightsSelectMenu
</script>
